const NotFound = () => {
	return (
		<div className="bg-white flex w-full h-full my-2 rounded-md items-center justify-center">
			<div className="text-2xl">Página não encontrada</div>
		</div>
	);
};

export default NotFound;
